<template>
  <template
    v-if="provisionedUser === undefined"
  >
    <m-tooltip placement="left">
      <template #title>
        {{ t('userProvisioningStatusBadge.notAvailableTooltip') }}
      </template>
      <div class="_status">
        <m-icon
          type="dot"
          size="28"
          :style="{ width: '1.6rem', marginRight: '.4rem', marginLeft: '.6rem' }"
        />
        <div>{{ t('userProvisioningStatusBadge.notAvailable') }}</div>
      </div>
    </m-tooltip>
  </template>
  <m-dropdown
    v-if="provisionedUser !== undefined"
    :title="t('userProvisioningStatusBadge.status')"
    close-on-click
    @click.stop
  >
    <m-btn
      hide-border
      xs
    >
      <m-icon
        type="api"
        :color="iconColor"
        :style="{ width: '1.6rem', marginRight: '.4rem' }"
      />
      <template v-if="provisionedUser.deactivatedAt === null">
        {{ t('userProvisioningStatusBadge.enabled') }}
      </template>
      <template v-else>
        {{ t('userProvisioningStatusBadge.disabled') }}
      </template>
    </m-btn>
    <template #overlay>
      <m-card list>
        <m-card-item
          :clickable="false"
          light
          @click.stop
        >
          {{ $t('userProvisioningStatusBadge.provisionedAt') }} {{ formatDate(provisionedUser.createdAt) }}
        </m-card-item>
        <m-card-item
          v-if="provisionedUser.activ !== null && !provisionedUser.active && provisionedUser.deactivatedAt === null"
          :clickable="false"
          icon="non-automatic"
          @click.stop
        >
          {{ $t('userProvisioningStatusBadge.remotelyDisabled') }}
        </m-card-item>
        <m-card-item
          v-if="provisionedUser.deactivatedAt !== null"
          :clickable="false"
          icon="non-automatic"
          @click.stop
        >
          {{ $t('userProvisioningStatusBadge.deactivatedSince') }} {{ formatDate(provisionedUser.deactivatedAt) }}
        </m-card-item>
        <user-provisioning-disable-action :provisioned-user="provisionedUser" />
      </m-card>
    </template>
  </m-dropdown>
</template>

<script setup>
import UserProvisioningDisableAction from '@/components/UserProvisioningDisableAction.vue';
import colors from 'shared/colors';
import useUserProvisioning from '@/composables/user-provisioning/user-provisioning';
import { DateTime } from 'luxon';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const { findProvisionedUser } = useUserProvisioning();

const props = defineProps({
  user: {
    type: Object,
    required: true,
  },
});

const provisionedUser = computed(() => findProvisionedUser(props.user));

const formatDate = (date) => {
  switch (typeof (date)) {
    case 'object':
      return DateTime.fromObject(date).toLocaleString(DateTime.DATE_SHORT);
    default:
      return DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);
  }
};

const iconColor = computed(() => {
  if (provisionedUser.value?.deactivatedAt !== null) {
    return colors.red.base;
  }

  return colors.green.base;
});
</script>

<style>
._status {
  display: inline-flex;
  align-items: center;
}
</style>
